
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flights",
      function () {
        return require("private-next-pages/flights.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flights"])
      });
    }
  